export const SOBJECT_PROJECT = "Project__c";
export const SOBJECT_PROJECT_OBJECTIVE = "Project_Objective__c";
export const SOBJECT_PROJECT_PAGE = "Project_Page__c";
export const SOBJECT_PROJECT_PAGE_COMPONENT = "Project_Page_Component__c";
export const SOBJECT_PROJECT_QUAL_STEP = "Project_Qualification_Step__c";
